export enum PhotoFlags {
  ActuarProfile = 1,
  TreinoProfile = 2,
  Facial = 4,
}
